export const PROFILES_PER_PAGE = 30;
export const FOLLOWERS_PER_PAGE = 10;
export const BLACKLIST_PER_PAGE = 10;


// WEBPACK FOOTER //
// ./src/constants/profiles.js